module.exports = __webpack_public_path__ + "img/logo-signature.a3bb8110.png";